import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionHeading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        textAlign: "left"
    },
    dialogContent: {
        paddingTop: 0
    }
}));

const DialogTitle = (props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{paddingRight: 24}}>{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function MyDialog(props) {
    const {subtitle, closeButtonText, confirmButtonText, handleConfirm, disableBackdropClick} = props;
    const [open, setOpen] = React.useState(false);    
    const [title, setTitle] = React.useState(null);
    const classes = useStyles();

    React.useEffect(() => {
        if(props.open){
            setOpen(props.open);
            setTitle(props.title);
        } else {
          handleClose()
        }
    }, [props.open]);
 
    const handleClose = () => {
        props.close();
        setTitle(null);
        setOpen(false);
    };

    return (
        <Dialog disableBackdropClick={disableBackdropClick || false} fullWidth={props.fullWidth !== undefined ? props.fullWidth : true} maxWidth={props.maxWidth !== undefined ?  props.maxWidth : "lg"} onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle id="customized-dialog-title" onClose={handleClose} classes={classes}>
              <Typography variant="h6" component="div">
                {title}
              </Typography>
              <Typography variant="overline" component="div">
                {subtitle}
              </Typography>
            </DialogTitle>
            <DialogContent dividers style={{paddingTop: 0, }} className={props.contentClass || ""}>
                {props.content}
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                    {closeButtonText || "Close"}
                </Button>
                {
                  confirmButtonText && handleConfirm && (
                    <Button autoFocus variant="outlined" onClick={handleConfirm} color="primary">
                        {confirmButtonText}
                    </Button>
                  )
                }
            </DialogActions>
        </Dialog>
    );
}

MyDialog.prototype = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    content: PropTypes.any.isRequired,
    maxWidth: PropTypes.any,
    fullWidth: PropTypes.bool,
    contentClass: PropTypes.any,
};